import { Row, Nav } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledRow = styled(Row)`
    background-color: #ffffff !important;
`;

export const StyledTh = styled.th`
    background-color: #f2f2f2;
`;

export const StyledTitle = styled.h3`
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #707070;
`;

export const StyledBreadcrumbTitle = styled.h3`
    font-style: normal;
    font-weight: bold;
    position: absolute;
    left: 1%;
    font-size: 17px;
    color: #707070;
`;

export const StyledNavLink = styled(Nav.Link)`
    font-size: 16px;
`;
